import React, { useContext } from "react";
import styled, { ThemeContext } from "styled-components";
import { LayoutProps, SpaceProps, TypographyProps } from "styled-system";
import isEqual from "lodash/isEqual";
import { Box } from "../Box";
import { Link } from "../Link";
import { Title } from "../Title";
import { LinksProps } from "./index";

const UL = styled.ul`
  list-style: none;
  padding-left: 0px;
  margin: 0;
`;

const LI = styled.li`
  &:first-child {
    margin-top: ${({ theme }) => theme.space[0]}px;
  }
  margin-top: ${({ theme }) => theme.space[3]}px;
`;

const StyledTitle = styled(props => <Title as="h2" m={0} mb={3} {...props} />)``;

export const Links: React.FC<LinksProps & TypographyProps & SpaceProps & LayoutProps> = ({ title, links, variant, ...rest }) => {
  const {
    colors: { greyLight },
  } = useContext(ThemeContext);

  const isTitleAbove = title && isEqual(variant, "TitleAbove");
  const isTitleInside = title && isEqual(variant, "TitleInside");

  return (
    <Box data-testid="links" {...rest}>
      {isTitleAbove && <StyledTitle data-testid="links__title--above">{title}</StyledTitle>}
      <Box bg={greyLight} p={4}>
        {isTitleInside && <StyledTitle data-testid="links__title--inside">{title}</StyledTitle>}
        <UL>
          {links.map(({ linkText, href }) => (
            <LI key={linkText}>
              <Link href={href}>{linkText}</Link>
            </LI>
          ))}
        </UL>
      </Box>
    </Box>
  );
};

Links.defaultProps = {
  title: "",
  variant: "TitleAbove",
};
